import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';

import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import {
  EXERCISE_QUIZ,
  EXERCISE_QUIZ_QUESTION,
  EXERCISE_QUIZ_QUESTIONS,
  ExerciseQuizPluginOptions,
} from './types';
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';
import { ExerciseQuizReadOnlyPlugin } from './ExerciseQuizReadOnlyPlugin';

const ExerciseQuiz = dynamicEditorComponent(() =>
  import('./components/ExerciseQuiz').then((mod) => mod.ExerciseQuiz)
);
const ExerciseQuizQuestion = withDynamicBlogEditorPluginHydration({ canInteract: true })(
  dynamicEditorComponent(
    () => import('./components/ExerciseQuizQuestion').then((mod) => mod.ExerciseQuizQuestion),
    {
      dependsOn: ExerciseQuiz,
    }
  )
);
const ExerciseQuizQuestions = withDynamicBlogEditorPluginHydration({ canInteract: true })(
  dynamicEditorComponent(
    () => import('./components/ExerciseQuizQuestions').then((mod) => mod.ExerciseQuizQuestions),
    {
      dependsOn: ExerciseQuiz,
    }
  )
);

export const ExerciseQuizPlugin = (options?: ExerciseQuizPluginOptions): SlatePlugin => {
  if (options?.isReadOnly) {
    return ExerciseQuizReadOnlyPlugin(options);
  }

  return {
    renderElement: (renderProps: RenderElementProps) => {
      const { element } = renderProps;

      switch (element?.type) {
        case EXERCISE_QUIZ:
          return <ExerciseQuiz {...renderProps} {...options} />;
        case EXERCISE_QUIZ_QUESTIONS:
          return <ExerciseQuizQuestions {...renderProps} {...options} />;
        case EXERCISE_QUIZ_QUESTION:
          return <ExerciseQuizQuestion {...renderProps} {...options} />;
        default:
      }

      return null;
    },
  };
};
